var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        "before-close": _vm.close,
        width: "70%",
        "custom-class": "upload-history",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog-title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("span", [_vm._v("历史记录")]),
          _c("i", {
            staticClass: "el-icon-refresh refresh-icon",
            on: { click: _vm.onQuery },
          }),
        ]
      ),
      _c(
        "div",
        { staticClass: "pb16 pl16 pr16" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.list, height: "570", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "任务ID", width: "90" },
              }),
              _c("el-table-column", {
                attrs: { width: "300", prop: "status" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c("el-row", [_vm._v("文件名")]),
                        _c("el-row", [_vm._v("状态")]),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-row", [
                          _vm._v(_vm._s(scope.row.originalFileName)),
                        ]),
                        _c("el-row", [_vm._v(_vm._s(scope.row.statusText))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { width: "100", prop: "success" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c("el-row", [_vm._v("成功数量")]),
                        _c("el-row", [_vm._v("SPU/SKU")]),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-row", [
                          _vm._v(
                            _vm._s(scope.row.productCount) +
                              "/" +
                              _vm._s(scope.row.skuCount)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  align: "center",
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "finishTime",
                  label: "完成时间",
                  align: "center",
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "errorMessage", label: "失败原因" },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "mt16", attrs: { type: "flex", justify: "end" } },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20, 60, 80],
                  "page-size": _vm.queryParams.limit,
                  "current-page": _vm.queryParams.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onPageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }